import React, {useEffect} from 'react';

// import Custom Components
import OwlCarousel from '../features/owl-carousel';

import CategoryBanner from './category-banner';
import ProductNine from '../features/product/product-nine';
import { productSlider1 } from '../settings';

import './productliststyle.css';

// import Actions & Services & data
import { addToCart, toggleWishlist, addToCompare, showQuickViewModal } from '../../actions';

import data from '../../mock_data/data';
import { getProductsByCategory } from '../../services';
import { connect } from 'react-redux';

function ProductList(categories){

}

function ProductCollection( props ) {
    const { addToCart, toggleWishlist, addToCompare, showQuickViewModal, category } = props;

    let products = props.products;
    let variants = props.variants;

    products = getProductsByCategory( products.slice( 0, 10 ), category );


    return (
        <div className="row cat-banner-row clothing" style={{ position:"relative"}}>
            <div className="col-sm-6 col-md-6" style={{position:'relative', height:300,marginTop:5}}>
                <CategoryBanner index={ props.index } />
            </div>
            <div className="col-sm-6 col-md-6" style={{position:'relative', height:300,marginTop:5}}>
                <CategoryBanner index={ props.index2 } />
            </div>


            {
                /*

            <div className="col-xl-9 col-xxl-8" style={{ marginTop: '50px'}}>
                <OwlCarousel adClass="owl-full carousel-equal-height carousel-with-shadow" style={{ marginLeft: '-100px'}} carouselOptions={ productSlider1 }>
                    { props.index == 4 &&
                        variants.variantsById1.map( ( item, index ) =>
                            <ProductNine product={ item }
                                key={ category + '/' + index }
                                onAddToCart={ addToCart }
                                onToggleWishlist={ toggleWishlist }
                                onAddToCompare={ addToCompare }
                                showQuickView={ showQuickViewModal } />
                        )
                    }
                    { props.index == 6 &&
                        variants.variantsById2.map( ( item, index ) =>
                            <ProductNine product={ item }
                                key={ category + '/' + index }
                                onAddToCart={ addToCart }
                                onToggleWishlist={ toggleWishlist }
                                onAddToCompare={ addToCompare }
                                showQuickView={ showQuickViewModal } />
                        )
                    }
                    { props.index == 2 &&
                        variants.variantsById3.map( ( item, index ) =>
                            <ProductNine product={ item }
                                key={ category + '/' + index }
                                onAddToCart={ addToCart }
                                onToggleWishlist={ toggleWishlist }
                                onAddToCompare={ addToCompare }
                                showQuickView={ showQuickViewModal } />
                        )
                    }
                    { props.index == 3 &&
                        variants.variantsById4.map( ( item, index ) =>
                            <ProductNine product={ item }
                                key={ category + '/' + index }
                                onAddToCart={ addToCart }
                                onToggleWishlist={ toggleWishlist }
                                onAddToCompare={ addToCompare }
                                showQuickView={ showQuickViewModal } />
                        )
                    }
                </OwlCarousel>
            </div>

            */
            }

        </div>
    )
}

export const mapStateToProps = ( state, props ) => {
    return {
        variants: state.variants ? state.variants : [],
        products: state.data.products ? state.data.products : []
    }
}

export default ( connect )( mapStateToProps, {  addToCart, toggleWishlist, addToCompare, showQuickViewModal } )( ProductCollection );